import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularEuro: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_euro"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="euro icon"
      {...restProps}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 40 40"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.7904 25.1676L26.4961 24.319C26.1399 25.66 25.4537 26.7076 24.4375 27.4619C23.4213 28.2162 22.3056 28.5933 21.0904 28.5933C19.6866 28.5933 18.4871 28.169 17.4918 27.3204C16.4966 26.4719 15.7894 25.2828 15.3704 23.7533H20.839L21.4675 21.7104H14.9932C14.9304 21.2076 14.899 20.6733 14.899 20.1076C14.899 19.6047 14.9094 19.2381 14.9304 19.0076H22.0961L22.7247 16.9647H15.2447C15.6637 15.2885 16.397 13.979 17.4447 13.0362C18.4923 12.0933 19.7494 11.6219 21.2161 11.6219C22.3894 11.6219 23.4161 11.9466 24.2961 12.5962C25.1761 13.2457 25.7942 14.1571 26.1504 15.3304L28.4132 14.2619C27.8475 12.7114 26.9204 11.5171 25.6318 10.679C24.3432 9.84092 22.798 9.42188 20.9961 9.42188C18.7751 9.42188 16.9418 10.0819 15.4961 11.4019C14.0504 12.7219 13.1075 14.5761 12.6675 16.9647H9.99609V19.0076H12.4161C12.3951 19.2381 12.3847 19.6047 12.3847 20.1076C12.3847 20.5057 12.4056 21.04 12.4475 21.7104H9.99609V23.7533H12.7618C13.2647 25.9743 14.2285 27.7028 15.6532 28.939C17.078 30.1752 18.8799 30.7933 21.059 30.7933C22.819 30.7933 24.4061 30.2905 25.8204 29.2847C27.2347 28.279 28.2247 26.9066 28.7904 25.1676Z"
        />
      </svg>
    </span>
  );
};

export { RegularEuro };
